import { withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { withFallback } from '@/lib/searchParams'
import { SentryErrorPage } from '@/pages/error/SentryErrorPage'
import { StatsPageRouter } from '@/pages/stats/StatsPageRouter'

const SelectionModeZod = z.enum(['manual', 'fixedDate', 'weekday', 'isoWeek'])
const StatsSectionZod = withFallback(z.enum(['requests', 'configuration']), 'requests')

const statsSearchZod = z.object({
  // Section selector (requests chart or configuration history)
  section: StatsSectionZod,
  regionId: z.string().optional(),
  // For section 'requests' - Selection mode
  mode: withFallback(SelectionModeZod, 'manual'),
  // For mode 'manual': list of dates
  dates: z
    .union([z.string(), z.array(z.string())])
    .optional()
    .transform((v) => {
      if (!v) return []
      if (Array.isArray(v)) return v
      // Handle comma-separated string
      return v.split(',').filter(Boolean)
    }),
  // For mode 'fixedDate': day of month (23, 24, or 31)
  fixedDay: z.coerce.number().optional(),
  // For mode 'weekday': day of week (0-6, Sunday = 0)
  weekday: z.coerce.number().optional(),
  // For mode 'isoWeek': reference date (YYYY-MM-DD or 'now')
  referenceDate: z.string().optional(),
  // For section 'configuration': operating date (YYYY-MM-DD or 'now')
  operatingDate: z.string().optional(),
})

export const Route = createFileRoute('/stats/')({
  component: withErrorBoundary(StatsPageRouter, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  validateSearch: statsSearchZod,
})
